import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
    QueryList,
    ViewChild,
    ViewChildren,
} from '@angular/core';

import { keyCode } from '@ridango/core/lib/enums/keyboard.enum';
import { ListService } from '@ridango/core/lib/services';

let identifier = 0;

@Component({
    selector: 'ridango-card-actions-selector',
    templateUrl: './card-actions-selector.component.html',
    styleUrls: ['./card-actions-selector.component.css'],
})
export class CardActionsSelectorComponent {
    @Input() isOpened = false;
    @Input() disabled = false;
    @Input() actions = [];
    @Input() locale = 'en';

    @Output() onDropdownStatusChange = new EventEmitter<boolean>();
    @Output() onActionClicked = new EventEmitter<string>();

    @ViewChild('menuButton') menuButton: ElementRef;
    @ViewChildren('menuItem') menuItems: QueryList<ElementRef>;

    selectedIndex = 0;

    menuButtonId = `actions-selector-menu-button-${++identifier}`;
    menuId = `actions-selector-menu-${identifier}`;

    constructor(private eRef: ElementRef, private listService: ListService) {}

    @HostListener('document:click', ['$event']) onClickOut(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.onDropdownStatusChange.emit(false);
            this.selectedIndex = 0;
        }
    }

    actionClicked(action: string) {
        this.onActionClicked.emit(action);
        this.isOpened = false;
    }

    openClicked(event) {
        event.stopPropagation();
        event.preventDefault();

        if (!this.disabled && !this.isOpened) {
            this.onDropdownStatusChange.emit(true);
            setTimeout(() => this.menuItems.toArray()[this.selectedIndex].nativeElement.focus());
        } else {
            this.onDropdownStatusChange.emit(false);
        }
    }

    closeMenu(): void {
        this.onDropdownStatusChange.emit(false);
        this.selectedIndex = 0;
        this.menuButton.nativeElement.focus();
    }

    onMenuItemKeyDown(event: KeyboardEvent, action: string) {
        switch (event.keyCode) {
            case keyCode.ENTER:
            case keyCode.SPACE:
                event.preventDefault();
                this.actionClicked(action);
                this.closeMenu();
                break;
            case keyCode.ESCAPE:
            case keyCode.TAB:
                this.closeMenu();
                break;
            case keyCode.ARROW_DOWN:
                event.preventDefault();
                this.selectNextItem(1);
                break;
            case keyCode.ARROW_UP:
                event.preventDefault();
                this.selectNextItem(-1);
                break;
        }
    }

    selectNextItem(direction: number): void {
        this.selectedIndex = this.listService.getNextCyclicIndex(this.selectedIndex, direction, this.actions.length);
        setTimeout(() => this.menuItems.toArray()[this.selectedIndex].nativeElement.focus());
    }
}
